import { useMemo, useState } from "react"

import type { Issue, Project } from "@productlane/zero"
import { getRequestStatusLabel } from "@productlane/lib/src/support-requests"
import { RequestsListWrapper } from "@productlane/ui"

import { groupIssuesAndProjects } from "./group-issues-projects"
import { IssueTableItem } from "./issue-table-item"
import { ProjectTableItem } from "./project-table-item"

export const GroupedIssuesProjectsTable = ({
	categorizedIssues,
	categorizedProjects,
}: {
	categorizedIssues: Record<string, Issue[]>
	categorizedProjects: Record<string, Project[]>
}) => {
	const groups = useMemo(
		() =>
			groupIssuesAndProjects(
				Object.values(categorizedIssues).flat(),
				Object.values(categorizedProjects).flat(),
			),
		[categorizedIssues, categorizedProjects],
	)
	const [collapsed, setCollapsed] = useState<Record<string, boolean>>({
		completed: true,
	})

	if (groups.length === 0) return null

	return (
		<div className="px-6">
			{groups.map(({ status, statusType, requests }) => (
				<RequestsListWrapper
					key={status}
					title={getRequestStatusLabel(status)}
					statusType={statusType}
					count={requests.length}
					collapsible
					collapsed={collapsed[status] ?? false}
					onToggle={() =>
						setCollapsed((prev) => ({ ...prev, [status]: !prev[status] }))
					}
				>
					{requests.map((row) =>
						row.type === "project" ? (
							<ProjectTableItem
								key={row.item.id}
								project={row.item}
								className="px-3"
							/>
						) : (
							<IssueTableItem
								key={row.item.id}
								issue={row.item}
								className="px-3"
							/>
						),
					)}
				</RequestsListWrapper>
			))}
		</div>
	)
}
